var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4a.5.5 0 01.5.5V5h4a.5.5 0 010 1H9v.5a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.278 6C5.565 6 5 6.567 5 7.25v10.5c0 .683.565 1.25 1.278 1.25h11.444c.713 0 1.278-.567 1.278-1.25V7.25C19 6.567 18.435 6 17.722 6H16.06a.506.506 0 01-.06-.004V6.5a.5.5 0 01-1 0v-2a.5.5 0 011 0v.504A.506.506 0 0116.06 5h1.662C18.972 5 20 6 20 7.25v10.5C20 19 18.973 20 17.722 20H6.278C5.028 20 4 19 4 17.75V7.25C4 6 5.027 5 6.278 5h.226a.5.5 0 010 1h-.226z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15a1 1 0 100 2 1 1 0 000-2zm7-3a1 1 0 112 0 1 1 0 01-2 0zm-3 3a1 1 0 100 2 1 1 0 000-2zm-1-3a1 1 0 112 0 1 1 0 01-2 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar24);
export default __webpack_public_path__ + "static/media/icon-calendar-24.b3b09770.svg";
export { ForwardRef as ReactComponent };